import { MetadataGetdataPostRequest, MetadataDatabankElementPageGetRequest, ResponseDataObject } from "@jobindsats/typescript-fetch-jobindsats";
import jobindsatsApi from "../../core/services/api-config";

export class MalingService {
    getMetadataMaalingValues(requestParameters: MetadataDatabankElementPageGetRequest) {
        return jobindsatsApi.getApi().metadataDatabankElementPageGet(requestParameters);
    }

    getData(requestParameters: MetadataGetdataPostRequest): Promise<ResponseDataObject> {
        return jobindsatsApi.getApi().metadataGetdataPost(requestParameters);
    }
}